'use client';
import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import AccessorySlider from './_AccessorySlider';
import AccessoryGrid from './_AccessoryGrid';
import AccessoryScroll from './_AccessoryScroll';
import { Wrapper, Section, ToutWrapper, HeaderTwo } from './styles';
import { MediaType } from '@repo/ui/src/types/image';
import { ToutContentProps } from '@repo/ui/src/types/toutContent';

interface CustomizeProps {
  headerTout: ToutContentProps;
  video: MediaType;
  showVideo: boolean;
  order: number;
  _testID?: string;
  background: string;
  reverse?: boolean;
  accessories: Array<{
    toutContent: ToutContentProps;
    img: {
      image: MediaType;
      altTag: string;
    };
  }>;
}

const CustomizeAccessories = ({
  headerTout,
  video,
  accessories,
  order,
  _testID,
  background,
  reverse,
}: CustomizeProps) => {
  const smAndDown = useMediaQuery('(max-width:1000px)');
  const darkGray = background === 'Dark Gray';

  return (
    <Section order={order} data-test-id={`customize_accessories_${_testID}`}>
      {video && (
        <AccessoryScroll
          headingLight={headerTout.headingLight}
          heading={headerTout.heading}
          align="left"
          description={headerTout.description}
          video={video as MediaType}
        />
      )}
      <Wrapper darkGray={darkGray}>
        {!video && (
          <ToutWrapper>
            <HeaderTwo
              headingLight={headerTout.headingLight}
              heading={headerTout.heading}
              align="left"
              headingStyleVariant="h1"
              divider
              dark
              description={headerTout.description}
            />
          </ToutWrapper>
        )}
        {smAndDown ? (
          <AccessorySlider accessories={accessories} />
        ) : (
          <AccessoryGrid accessories={accessories} reverse={reverse} />
        )}
      </Wrapper>
    </Section>
  );
};

export default CustomizeAccessories;
